export const API_URL = 'SOME_URL';
export const APP_URL = process.env.WEBSITE_APP_URL || 'https://www.jpsstore.com';

//
export const DEFAULT_TOAST_DURATION = 3000;
